import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

const NotificationTextImport = ({ importObject }) => {
  const intl = useIntl();

  if (!importObject) {
    return null;
  }

  if (
    importObject.status === 'failed' ||
    importObject.status === 'overlimit'
  ) {
    return (
      <span>
        {
          importObject.importer ?
            intl.formatMessage({ defaultMessage: `Your import from {name} failed` }, { name: importObject.importer.name }) :
            intl.formatMessage({ defaultMessage: 'Your import failed' })
        }

        {importObject.importer && (
          <>
            {' '}
            <Link to={`${window.location.pathname}?importer=${importObject.importer.id}`}>
              <strong>{intl.formatMessage({ defaultMessage: 'Check status' })}</strong>
            </Link>
          </>
        )}
      </span>
    );
  }

  return (
    <>
      {importObject.collection ? (
        <Link to={`/collections/${importObject.collection.uuid}`} target="_blank">
          <strong>{intl.formatMessage({ defaultMessage: 'Your import' })}</strong>
        </Link>
      ) : (
        intl.formatMessage({ defaultMessage: 'Your import ' })
      )}
      {
        importObject.importer
          ? intl.formatMessage({ defaultMessage: '{nbsp}from {name} is complete' }, { name: importObject.importer.name, nbsp: ' ' })
          : intl.formatMessage({ defaultMessage: ' is complete' })
      }
    </>
  );
};

NotificationTextImport.propTypes = {
  importObject: PropTypes.object,
};

NotificationTextImport.defaultProps = {
  importObject: null,
};

export default NotificationTextImport;
